export default "__VITE_ASSET__BMRiM33A__"